import React, { useState } from 'react';


import img2_9kg from "../images/Pedigree Puppy Chicken & Milk Sachet-Pouch_2.8kg.png";
import dogfooddry20kg from "../images/Pedigree Puppy Chicken & Milk_20 Kg.png"
import dogfooddry from "../images/Pedigree Puppy Chicken & Milk_5.5 kg.png"
import dry10kg from "../images/Pedigree Puppy Chicken & Milk_10kg.png";

import img1kg from "../images/Puppy Chicken & Milk Sachet-Pouch_1kg.png"
import img90gm from "../images/Pedigree Puppy Chicken & Milk Sachet-Pouch_90g.png";
import dryfooddog370gm from "../images/Pedigree Puppy Chicken & Milk Sachet-Pouch_370g.png";



import {
  FacebookShareButton, WhatsappShareButton, WhatsappIcon,
  FacebookIcon, TwitterShareButton, EmailShareButton, EmailIcon,

  LinkedinShareButton,
  LinkedinIcon,
  TwitterIcon,
} from "react-share";

function Doogdry() {
  const [selectedWeight, setSelectedWeight] = useState("90gm");




  const phoneNumber = "918927119640"; // Replace with your number (with country code, no +)
  const message = "Hello..";

  const encodedMessage = encodeURIComponent(message);
  const whatsappURL = `https://wa.me/${918927119640}?text=${encodedMessage}`;



  return (


    <>





      <br />





      <div className="album py-1">

        <div className="container">

          <div className="row">




            <div className="col-md-12 mt-3">
       
              <div className="card mb-4">
                <h4 className='btn-grad84'>PUPPY - CHICKEN & MILK for New Born Dog</h4>

                     
    

      {/* Product Image (direct <img> tag) */}
      {selectedWeight === "1kg" && (
        <img
          src={img1kg}
          alt="1kg"
          className=""
        />
      )}
      {selectedWeight === "90gm" && (
        <img
          src={img90gm}
          alt="90gm"
          className=""
        />
      )}
      {selectedWeight === "370gm" && (
        <img
          src={dryfooddog370gm}
          alt="90gm"
          className=""
        />
      )}
      {selectedWeight === "2.8kg" && (
        <img
          src={img2_9kg}
          alt="2.8kg"
          className=""
        />
      )}
      {selectedWeight === "5.5kg" && (
        <img
          src={dogfooddry}
          alt="5kg"
          className="w-64 h-64 border rounded-lg shadow"
        />
      )}
      {selectedWeight === "10kg" && (
        <img
          src={dry10kg}
          alt="10kg"
          className="w-64 h-64 border rounded-lg shadow"
        />
      )}
      {selectedWeight === "20kg" && (
        <img
          src={dogfooddry20kg}
          alt="20kg"
          className="w-64 h-64 border rounded-lg shadow"
        />
      )}

      {/* Weight Buttons */}
      <div className="flex gap-3 mt-2">
        {["90gm", "370gm", "1kg", "2.8kg", "5.5kg", "10kg", "20kg"].map((weight) => (
          <button
            key={weight}
            onClick={() => setSelectedWeight(weight)}
            className={`px-4 py-2 border rounded-lg text-lg font-medium 
              ${selectedWeight === weight ? "bg-black text-white" : "bg-white text-black"}`}
          >
            {weight}
          </button>
        ))}
      </div>
   

                <div className="card-body">
   {/* Title */}
      <h4 style={{color:"darkblue"}} className="text-xl font-semibold sty">
        Selected Weight: {selectedWeight}
      </h4>
                  <h6 className="card-text"> <b>Pedigree Dry Range</b></h6>

                  <p className="card-text mb-2"><small> Chicken &amp; Milk for Puppy is a wholesome meal, packed with essential nutrients vital to the healthy growth of your pet.</small></p>
                  <p style={{ color: "Gray" }} className="card-text mb-2">Starting M.R.P.: <del> ₹25</del> </p>
                  <button className='btn btn-outline-danger btn-sm mb-2'>16 %OFF</button>
                  <p><b>Flat 18% off on 15 kg and 20 kg R bags.</b></p>
                  <h6 className="card-text" >₹ 90GM -21/-, 370GM -92/-, 1KG -244/-, 2.8KG- 575/-, 5.5KG -1218/-, 10KG -2091/-, 20KG -3362/-  </h6>
                  <p className="card-text mb-0">free home delivery</p>
                  <div className="d-flex justify-content-between align-items-center">

                    <a href='tel: 8927119640'> <p className="healthpetproducts mt-2">Call Book</p></a>
                    <a href={whatsappURL} target="_blank" rel="noopener noreferrer">
                      <button style={{ padding: "4px 12px", backgroundColor: "#1B8755", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
                          <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                        </svg>
                      </button>
                    </a>          </div>
                  <button type="button" className="btn btn btn-dark me-1">
                    Share  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-share-fill" viewBox="0 0 16 16">
                      <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                    </svg>
                  </button> < FacebookShareButton url="https://www.thepetplazza.com/dog-food" className="me-2 mt-2 " quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                  >
                    <FacebookIcon size={37} round={true} />
                  </FacebookShareButton>

                  <  WhatsappShareButton url="https://www.thepetplazza.com/dog-food" className="me-2 mt-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                  >
                    <WhatsappIcon size={37} round={true} />
                  </ WhatsappShareButton>

                  <  TwitterShareButton url="https://www.thepetplazza.com/dog-food" className="me-2 mt-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                  >
                    <TwitterIcon size={37} round={true} />
                  </ TwitterShareButton>

                  <  LinkedinShareButton url="https://www.thepetplazza.com/dog-food" className="me-2 mt-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                  >
                    <  LinkedinIcon size={37} round={true} />
                  </ LinkedinShareButton>

                  <  EmailShareButton url="https://www.thepetplazza.com/dog-food" className=" mt-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                  >
                    <  EmailIcon size={37} round={true} />
                  </ EmailShareButton>
                  <div className="d-flex justify-content-between align-items-center">



                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>
      </div>

    </>

  );
}

export default Doogdry;